<template>
  <VList
    ref="userMenu"
    class="px-4 mb-md-2 navigation-user-menu"
    density="compact"
    nav
  >
    <VListItem
      v-if="userStore.user"
      class="pl-1"
      :title="user.name"
      link
      data-testid="userMenuItem"
    >
      <template #prepend>
        <CommonAvatar
          :src="user.avatar"
          :user-name="user.name"
          :use-initials="true"
          size="40"
        />
      </template>
      <VMenu
        v-model="isMenuActive"
        theme="TwLight"
        activator="parent"
        location="top"
      >
        <VCard
          border
          class="pa-3"
          width="238"
        >
          <VList
            class="pa-0"
            density="compact"
            nav
          >
            <template
              v-for="(item, index) in userItems"
              :key="index"
            >
              <TheNavigationMenuItem
                :class="{ 'text-error' : item.title === 'Logout' }"
                :nav-item="item"
                :is-expanded="isExpanded"
                :tooltip-visible="false"
              />
            </template>
          </VList>
        </VCard>
      </VMenu>
    </VListItem>
  </VList>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';
import { usePrimaryNavigation } from '@/composables/usePrimaryNavigation';
import { useUserStore } from '@/stores/userStore';
import { CommonAvatar } from '@teamworksdev/vuetify';
import TheNavigationMenuItem from '@/components/navigation/TheNavigationMenuItem.vue';

const { isExpanded = true } = defineProps<{
  isExpanded: boolean;
}>();

const isMenuActive = ref(false);

const { userItems } = usePrimaryNavigation();

const userStore = useUserStore();
const user = computed(() => ({
  name: `${userStore.user?.firstName} ${userStore.user?.lastName}`,
  avatar: userStore.user?.avatar ?? null,
}));

</script>
